import React from "react";
import { ResponseStatus } from "../../dtos/respondent";
import styles from "./guest-list-details.module.scss";

interface GuestListDetailsProps {
    respondents: {
        coming?: Array<{ fullName: string }>;
        maybe?: Array<{ fullName: string }>;
        declined?: Array<{ fullName: string }>;
    };
    status: ResponseStatus;
}

const GuestListDetails: React.FC<GuestListDetailsProps> = ({ respondents, status }) => {
    const getStatusTitle = (status: ResponseStatus): string => {
        switch (status) {
            case ResponseStatus.COMING:
                return "Coming";
            case ResponseStatus.MAYBE:
                return "Maybe";
            case ResponseStatus.DECLINED:
                return "Declined";
            default:
                return "Unknown";
        }
    };

    const getRespondentsForStatus = (status: ResponseStatus) => {
        switch (status) {
            case ResponseStatus.COMING:
                return respondents.coming || [];
            case ResponseStatus.MAYBE:
                return respondents.maybe || [];
            case ResponseStatus.DECLINED:
                return respondents.declined || [];
            default:
                return [];
        }
    };

    const respondentsList = getRespondentsForStatus(status);
    const statusTitle = getStatusTitle(status);

    return (
        <div className={styles.guestListDetails}>
            {respondentsList.length === 0 ? (
                <p className={styles.emptyMessage}>No one has responded as {statusTitle.toLowerCase()} yet.</p>
            ) : (
                <div className={styles.respondentsList}>
                    {respondentsList.map((respondent, index) => (
                        <div key={index} className={styles.respondentItem}>
                            <span className={styles.respondentName}>{respondent.fullName}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GuestListDetails;
